import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { TranslateModule } from '@ngx-translate/core';
import { UpperCasePipe } from '@angular/common';
import { AuthenticationService } from '@app-services/auth/authentication.service';
import { environment } from '@app-environments/environment';
import { IntervalService } from '@app-services/interval.service';
import { Router } from '@angular/router';
import { MatchError } from '@app-services/errors/error-matcher';

@Component({
  selector: 'app-default-page',
  imports: [
    MatButtonModule,
    MatFormFieldModule,
    TranslateModule,
    UpperCasePipe,
  ],
  templateUrl: './default-page.component.html',
  styleUrls: ['./default-page.component.scss'],
})
export class DefaultPageComponent implements OnInit, OnDestroy {
  authError: boolean;
  clientId: string;
  isLoggedIn = false;
  isError = false;
  typeAuth = environment.production
    ? environment.isCredem
      ? 'loginCredem'
      : 'login'
    : 'all';

  config: { title: string; typeAuth: string[]; logIn: () => void }[] = [
    {
      title: environment.production ? 'loginAgain' : 'login',
      typeAuth: ['all', 'login'],
      logIn: () => this.logIn(),
    },
    {
      title: environment.production ? 'loginAgain' : 'loginCredem',
      typeAuth: ['all', 'loginCredem'],
      logIn: () => this.logInCredem(),
    },
  ];

  infoButtons: { title: string; typeAuth: string[]; logIn: () => void }[] = [];

  constructor(
    private authenticationService: AuthenticationService,
    private intervalService: IntervalService,
    protected router: Router,
    public matchError: MatchError
  ) {}

  async ngOnInit(): Promise<void> {
    this.isLoggedIn = this.authenticationService.isLoggedIn();
    if (this.isLoggedIn) {
      this.router.navigate([`/`]);
    } else {
      const parameters = new URLSearchParams(window.location.search);
      const authError = parameters.get('status');
      this.authError = !!authError && authError === 'auth_error';
      this.infoButtons = this.config.filter(item =>
        item.typeAuth.includes(this.typeAuth)
      );
    }
  }

  logIn(): void {
    this.authenticationService.logIn();
  }

  logInCredem(): void {
    this.authenticationService.logInCredem();
  }

  ngOnDestroy(): any {
    this.intervalService.clearAllIntervals();
  }
}
